import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { RESET_PASSWORD } from '../graphql/mutations/resetPassword'; // Adjust path

const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [resetPassword, { loading, error }] = useMutation(RESET_PASSWORD);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await resetPassword({
        variables: { token, newPassword },
      });
      setMessage(data.resetPassword.message);
      setTimeout(() => navigate('/login'), 3000); // Redirect after success
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{ color: 'white', padding: 20 }}>
      <h2>Reset Your Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="Enter new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>
      {error && <p style={{ color: 'red' }}>{error.message}</p>}
      {message && <p style={{ color: 'green' }}>{message}</p>}
    </div>
  );
};

export default ResetPasswordPage;
